module.exports = __webpack_public_path__ + "img/the-field-gal-1.5f70c993.jpg";